<template>
    <transition name="modal-fade" class="modal-fade">
      <div class="modal-backdrop">
        <form @submit.prevent="submitSession" action="#" method="post">
          <div class="session-modal" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription">
            <header class="modal-header">
              <slot name="header">Enter Session Name</slot>              
            </header>
            <section class="session-modal-body">
              <label for="sessionName">Session Name:</label>
              <input type="text" id="sessionName" v-model="sessionName" class="input-field" required />
            </section>
            <footer class="modal-footer">
              <slot name="footer">
                <button type="button" class="btn btn-primary" @click="close">Cancel</button>
                <input type="submit" class="btn btn-green" value="Submit">
              </slot>
            </footer>
          </div>
        </form>
      </div>
    </transition>
  </template>
  
  <script>
  export default {
    name: 'CreateSandboxSession',
    data () {
      return {
        sessionName: ''
      }
    },
    methods: {
      close () {
        this.$emit('close')
      },
      submitSession () {
        this.$emit('submitSession', this.sessionName)
        this.close()
      }
    }
  }
  </script>
  
  <style>
  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .session-modal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
    width: 300px;
    border-radius: 5px;
  }
  
  .modal-header, .modal-footer {
    padding: 15px;
    text-align: center;
    font-size: 18px;
  }
  
  .session-modal-body {
    padding: 10px 15px;
  }
  
  .input-field {
    width: 100%;
    padding: 8px;
    margin-top: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  
  .btn-close {
    border: none;
    font-size: 20px;
    cursor: pointer;
    background: transparent;
  }
  
  .btn-green {
    color: white;
    background: #0D9488;
    border: 1px solid #0D9488;
    border-radius: 4px;
    padding: 8px 12px;
  }
  
  .modal-fade-enter, .modal-fade-leave-active {
    opacity: 0;
  }
  
  .modal-fade-enter-active, .modal-fade-leave-active {
    transition: opacity .5s ease;
  }
  </style>
  


// WEBPACK FOOTER //
// createSandboxSession.vue?3844ce22